import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, shareReplay, throwError } from "rxjs";


@Injectable({providedIn: 'root'})
export class UtilsService { // TODO: nome piu specializzato ??
    
    // Una cache per ogni api call, mappata per parametri. La chiave della mappa sarà una stringa che rappresenta i parametri
    private cacheMap: Map<string, Observable<any>> = new Map();

    constructor(private http: HttpClient) { }

    manageApiCalls(url: string, params: {}): Observable<any>{
        // Converto l'oggetto in JSON string.
        // Ordina le chiavi per garantire che {name: 'a', id: 1} abbia la stessa chiave di {id: 1, name: 'a'}
        const orderedParams = JSON.stringify(Object.keys(params).sort().reduce((obj: any, key) => {
            obj[key] = (params as any)[key];
            return obj;
        }, {}));
        
        // Creo una chiave unica formata da url più i parametri. 
        const cacheKey = url + orderedParams;

        if (!this.cacheMap.has(cacheKey)) {
            const observableValue = this.http.get<any>(url, {params: params}).pipe(
                // Usato shareReplay per la cache
                shareReplay({
                    bufferSize: 1, // Memorizza l'ultimo valore emesso
                    refCount: true, // Rilascia la cache se non ci sono più sottoscrittori
                }),
                catchError(error => {
                    console.error(`Error fetching data for ${cacheKey}, clearing cache:`, error);
                    this.cacheMap.delete(cacheKey);; // Invalida la cache in caso di errore per questa cacheKey
                    return throwError(() => new Error('Failed to load'));
                })
            );
            this.cacheMap.set(cacheKey, observableValue);
        } else {
            console.log('Data from cache for params: ' + cacheKey );
        }
        return this.cacheMap.get(cacheKey)!;
    }
}